import { useStyle } from "@/classify"
import TextInput from "@/components/TextInput"
import { useQuantityStepper } from "@/hooks/QuantityStepper/useQuantityStepper"
import { Fragment } from "react"
import { useIntl } from "react-intl"
import defaultClasses from "./quantityStepper.module.css"

const QuantityStepper = ({
  initialValue = 1,
  itemId,
  min = 0,
  onChange = () => {},
  message,
  classes: propsClasses,
}) => {
  const { formatMessage } = useIntl()
  const classes = useStyle(defaultClasses, propsClasses)

  const talonProps = useQuantityStepper({
    initialValue,
    min,
    onChange,
  })

  const {
    isDecrementDisabled,
    isIncrementDisabled,
    handleBlur,
    handleDecrement,
    handleIncrement,
    maskInput,
  } = talonProps

  const errorMessage = message ? <div>{message}</div> : null

  return (
    <Fragment>
      <div className={classes.root}>
        <button
          aria-label={formatMessage({
            id: "quantity.buttonDecrement",
            defaultMessage: "Decrease Quantity",
          })}
          className={classes.button_decrement}
          disabled={isDecrementDisabled}
          onClick={handleDecrement}
          type="button"
          data-cy="Quantity-decrementButton"
        />
        <TextInput
          aria-label={formatMessage({
            id: "quantity.input",
            defaultMessage: "Item Quantity",
          })}
          data-cy="QuantityStepper-input"
          classes={{
            input: classes.input,
          }}
          field="quantity"
          id={itemId}
          inputMode="numeric"
          min={min}
          onBlur={handleBlur}
          pattern="[0-9]*"
        />
        <button
          aria-label={formatMessage({
            id: "quantity.buttonIncrement",
            defaultMessage: "Increase Quantity",
          })}
          className={classes.button_increment}
          disabled={isIncrementDisabled}
          onClick={handleIncrement}
          type="button"
          data-cy="Quantity-incrementButton"
        />
      </div>
      {errorMessage}
    </Fragment>
  )
}

export default QuantityStepper
